// utils/calculator.js
// Loan balance helper used by Seller NetSheet

function removeNonNumeric(value) {
  if (value === null || value === undefined) return '';
  return String(value).replace(/[^0-9.-]+/g, '');
}

// monthly payment calculator: accepts annualInterestRate in percent (e.g. 6 for 6%)
function pmt(interest, months, loan) {
  let amount = 0;
  // if months equals the formatted string '0.00' handle specially
  if (String(months) === '0.00') {
    amount = (loan * interest) / 1200;
  } else {
    months = parseInt(months, 10);
    interest = parseFloat(interest) / 1200;
    loan = parseFloat(loan);
    // formula per provided algorithm
    amount = interest * -loan * Math.pow((1 + interest), months) / (1 - Math.pow((1 + interest), months));
  }
  return parseFloat(amount).toFixed(2);
}

/**
 * Compute the loan balance payment details for the current month (or next month if applicable).
 * request: { loanCapacity, annualInterestRate, termInYears, startDate }
 * Returns paymentDetails { month: Date, payment, interest, principal, balance } or null if not found
 */
export function getLoanBalanceForSellerNetSheet(loanCapacity, annualInterestRate, termInYears, startDate) {

  const loanCapacityNum = parseFloat(removeNonNumeric(loanCapacity));
  const annualInterestRateNum = parseFloat(removeNonNumeric(annualInterestRate));
  const termInYearsNum = parseFloat(removeNonNumeric(termInYears));
  const numberOfPayments = Math.round(termInYearsNum * 12);

  const today = new Date();
  const startDateDate = new Date(startDate);

  const monthlyInterestRate = annualInterestRateNum / 1200;
  const monthlyPayment = parseFloat(pmt(annualInterestRateNum, numberOfPayments, loanCapacityNum)).toFixed(2);

  const arrBalance = [{ month: 0, payment: 0, interest: 0, principal: 0, balance: loanCapacityNum }];
  let loanBalance = null;

  for (let i = 1; i <= numberOfPayments; i++) {
  const paymentDate = new Date(startDateDate);
    paymentDate.setMonth(paymentDate.getMonth() + i);

    const previousBalance = parseFloat(arrBalance[i - 1].balance);
  const interestPayment = parseFloat((monthlyInterestRate * previousBalance).toFixed(2));
    const principalPayment = parseFloat((monthlyPayment - interestPayment).toFixed(2));
    const currentBalance = parseFloat((previousBalance - principalPayment).toFixed(2));

    const paymentDetails = {
      month: paymentDate,
      payment: Number(monthlyPayment),
      interest: interestPayment,
      principal: principalPayment,
      balance: currentBalance,
      interestRate: annualInterestRateNum

    };

    arrBalance.push(paymentDetails);

    // match current month/year or next month/year (per original logic)
    if (paymentDate.getMonth() === today.getMonth() && paymentDate.getFullYear() === today.getFullYear()) {
      loanBalance = paymentDetails;
      break;
    } else if (
      paymentDate.getMonth() === (today.getMonth() + 1) % 12 &&
      paymentDate.getFullYear() === (today.getMonth() === 11 ? today.getFullYear() + 1 : today.getFullYear())
    ) {
      loanBalance = paymentDetails;
      break;
    }
  }

  return loanBalance;
}

// keep backward-compatible alias
export const getLoanBalanceForQSNS = getLoanBalanceForSellerNetSheet;

const calculator = { getLoanBalanceForSellerNetSheet, getLoanBalanceForQSNS };

export default calculator;
